import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tile-content" }
const _hoisted_2 = { class: "legend" }
const _hoisted_3 = {
  key: 1,
  class: "empty-msg"
}

import { computed } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useI18n } from "vue-i18n";
import { GET_PROJECT_CONSUMPTION_BY_THEME } from "@/graphql/project/queries";
import { formatPrice, formatPercentage } from "@/helpers/utils";
import { ProjectRoutes } from "@/router/projectRoutes";
import ButtonIcon from "@/components/ButtonIcon.vue";
import GraphDonutWithLabel from "@/components/GraphDonutWithLabel.vue";
import GraphLegendItem from "@/components/GraphLegendItem.vue";
import TileDashboard from "@/components/TileDashboard.vue";
import ButtonContactAdmin from "@/components/ButtonContactAdmin.vue";
import { themeColor } from "@/helpers/themes/utils";
import { DonutDefinition, DonutSegment } from "@/helpers/typesDefinition";


export default /*@__PURE__*/_defineComponent({
  __name: 'TileProjectDashboardBudgetThemes',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const queryVariables = computed(() => {
  return { id: props.id };
});
const {
  result,
  loading: hasLoaded,
  error,
} = useQuery(GET_PROJECT_CONSUMPTION_BY_THEME, queryVariables);

const loading = computed(() => !hasLoaded && t("loading"));

const themes = computed(() => {
  return result.value?.project?.themes;
});

const totalAmount = computed(() => {
  if (!themes.value) return undefined;
  return themes.value.reduce((acc, theme) => acc + theme.performedAmount, 0);
});

const thematicPercentages = computed(() => {
  return themes.value
    ?.filter((t) => {
      return t.performedAmount && t.name;
    })
    .toSorted((t1, t2) => t2.performedAmount - t1.performedAmount)
    .reduce(
      (acc, theme, index) => {
        const { offset, items } = acc;

        const percentageRaw = theme.performedAmount
          ? theme.performedAmount / totalAmount.value
          : 0;
        const percentage = percentageRaw * 100;
        const percentageLabel = formatPercentage(percentageRaw);
        const color = themeColor(index);
        const segment = {
          ...theme,
          color,
          percentageLabel,
          percentage,
          total: totalAmount.value,
          offset,
        };

        const currentOffset = offset + (1 - percentageRaw) * 100;

        return {
          offset: currentOffset,
          items: [...items, segment],
        };
      },
      {
        offset: 0,
        items: [],
      },
    );
});

const segments = computed(() => {
  return thematicPercentages.value?.items || [];
});

const donutDefinition = computed((): DonutDefinition => {
  return {
    layers: [
      {
        id: "layer",
        segments: segments.value as DonutSegment[],
      },
    ],
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TileDashboard, {
    title: _ctx.$t('dashboard.title.budgetTheme'),
    loading: loading.value,
    error: _unref(error)?.message
  }, {
    actions: _withCtx(() => [
      _createVNode(ButtonIcon, {
        "icon-name": "material-symbols:apps",
        label: _ctx.$t('buttons.seeDetails'),
        "icon-position": "start",
        variant: "outline",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: _unref(ProjectRoutes).PROJECT_THEMATIC })))
      }, null, 8, ["label"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (segments.value.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(GraphDonutWithLabel, {
                "donut-definition": donutDefinition.value,
                labels: [
            {
              name: _ctx.$t('labels.total'),
              value: _unref(formatPrice)(totalAmount.value),
            },
          ],
                full: true
              }, null, 8, ["donut-definition", "labels"]),
              _createElementVNode("ul", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, (segment) => {
                  return (_openBlock(), _createBlock(GraphLegendItem, {
                    key: segment.id,
                    color: segment.color,
                    label: segment.name,
                    value: `${segment.percentageLabel} (${_unref(formatPrice)(
              (segment.total / 100) * segment.percentage,
            )})`
                  }, null, 8, ["color", "label", "value"]))
                }), 128))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("project.budgetThemes.empty")), 1),
              _createVNode(ButtonContactAdmin)
            ]))
      ])
    ]),
    _: 1
  }, 8, ["title", "loading", "error"]))
}
}

})